document.addEventListener('DOMContentLoaded', function() {
    const branchInput = document.querySelector('.branch-input');
    if (!branchInput) return;

    const branchIdHidden = document.querySelector('.branch-id-hidden');
    const branchOptions = document.querySelectorAll('#branches_list option');

    // 支部名からIDを取得するマップを作成
    const branchMap = {};
    branchOptions.forEach(option => {
        branchMap[option.value] = option.dataset.id;
    });

    branchInput.addEventListener('input', function() {
        const selectedName = this.value;
        if (branchMap[selectedName]) {
            branchIdHidden.value = branchMap[selectedName];
        } else {
            branchIdHidden.value = '';
        }
    });

    branchInput.addEventListener('change', function() {
        const selectedName = this.value;
        if (branchMap[selectedName]) {
            branchIdHidden.value = branchMap[selectedName];
        } else {
            branchIdHidden.value = '';
        }
    });

    // 合計点数を計算する関数
    function calculateTotalScore() {
        const addFields = [
            'regional_training_needs_score',
            'new_training_field_score',
            'career_consultant_qualification_score',
            'self_diagnosis_score',
            'guideline_certification_score',
            'regional_training_provision_score',
            'other_employment_rate_score',
            'employment_rate_bonus',
            'survey_result_bonus'
        ];

        let total = 0;

        // 加算フィールド
        addFields.forEach(fieldId => {
            const input = document.getElementById(fieldId);
            if (input && input.value) {
                total += parseFloat(input.value) || 0;
            }
        });

        // 減点フィールド
        const deductionInput = document.getElementById('deduction');
        if (deductionInput && deductionInput.value) {
            total -= parseFloat(deductionInput.value) || 0;
        }

        // 表示を更新（小数点以下がある場合のみ表示）
        const displayValue = Number.isInteger(total) ? total.toString() : total.toFixed(2).replace(/\.?0+$/, '');
        document.getElementById('total-score-display').textContent = displayValue;
    }

    // 各入力フィールドの変更時に合計を再計算
    document.querySelectorAll('.score-input').forEach(input => {
        input.addEventListener('input', calculateTotalScore);
    });

    // 初期表示時に合計を計算
    calculateTotalScore();

    // 就職期間の自動計算
    const openingDateInput = document.querySelector('input[name="opening_date"]');
    const closingDateInput = document.querySelector('input[name="closing_date"]');
    const employmentPeriodInput = document.querySelector('input[name="certification_application_detail[employment_period]"]');

    if (!openingDateInput || !closingDateInput || !employmentPeriodInput) return;

    function formatDateJP(date) {
        const days = ['日', '月', '火', '水', '木', '金', '土'];
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const ddd = days[date.getDay()];
        return `${yyyy}/${mm}/${dd}(${ddd})`;
    }

    function calculateEmploymentPeriod() {
        if (!openingDateInput.value || !closingDateInput.value) return;

        const openingDate = new Date(openingDateInput.value);
        const closingDate = new Date(closingDateInput.value);

        // 修了日 + 3ヶ月 (EDATE相当)
        const closingPlus3 = new Date(closingDate);
        closingPlus3.setMonth(closingPlus3.getMonth() + 3);

        employmentPeriodInput.value = formatDateJP(openingDate) + '~' + formatDateJP(closingPlus3);
    }

    openingDateInput.addEventListener('change', calculateEmploymentPeriod);
    closingDateInput.addEventListener('change', calculateEmploymentPeriod);

    // 受講生提出期限の自動計算（修了日 + 97日）
    const studentDeadlineInput = document.querySelector('input[name="certification_application_detail[employment_report_student_deadline]"]');

    function calculateStudentDeadline() {
        if (!closingDateInput.value || !studentDeadlineInput) return;

        const closingDate = new Date(closingDateInput.value);
        closingDate.setDate(closingDate.getDate() + 97);

        studentDeadlineInput.value = formatDateJP(closingDate);
    }

    closingDateInput.addEventListener('change', calculateStudentDeadline);

    // 支部への一次提出日の自動計算（開講日 ~ 修了日+3ヶ月）
    const branchFirstSubmissionInput = document.querySelector('input[name="certification_application_detail[employment_report_branch_first_submission_date]"]');

    function calculateBranchFirstSubmission() {
        if (!openingDateInput.value || !closingDateInput.value || !branchFirstSubmissionInput) return;

        const openingDate = new Date(openingDateInput.value);
        const closingDate = new Date(closingDateInput.value);

        const closingPlus3 = new Date(closingDate);
        closingPlus3.setMonth(closingPlus3.getMonth() + 3);

        branchFirstSubmissionInput.value = formatDateJP(openingDate) + '~' + formatDateJP(closingPlus3);
    }

    openingDateInput.addEventListener('change', calculateBranchFirstSubmission);
    closingDateInput.addEventListener('change', calculateBranchFirstSubmission);

    // 支部提出期限の自動計算（修了日 + 4ヶ月 - 1日）
    const branchDeadlineInput = document.querySelector('input[name="certification_application_detail[employment_report_branch_deadline]"]');

    function calculateBranchDeadline() {
        if (!closingDateInput.value || !branchDeadlineInput) return;

        const closingDate = new Date(closingDateInput.value);
        const closingPlus4Minus1 = new Date(closingDate);
        closingPlus4Minus1.setMonth(closingPlus4Minus1.getMonth() + 4);
        closingPlus4Minus1.setDate(closingPlus4Minus1.getDate() - 1);

        branchDeadlineInput.value = formatDateJP(closingPlus4Minus1);
    }

    closingDateInput.addEventListener('change', calculateBranchDeadline);

    // 雇用保険適用就職率の適用日の自動計算（修了日 + 7ヶ月）
    const insuranceRateDateInput = document.querySelector('input[name="certification_application_detail[insurance_employment_rate_applied_date]"]');

    function calculateInsuranceRateDate() {
        if (!closingDateInput.value || !insuranceRateDateInput) return;

        const closingDate = new Date(closingDateInput.value);
        const closingPlus7 = new Date(closingDate);
        closingPlus7.setMonth(closingPlus7.getMonth() + 7);

        insuranceRateDateInput.value = formatDateJP(closingPlus7);
    }

    closingDateInput.addEventListener('change', calculateInsuranceRateDate);

    // コース名を訓練科名から自動取得
    const trainingCourseNameInput = document.querySelector('input[name="training_course_name"]');
    const courseNameInput = document.querySelector('input[name="certification_application_detail[course_name]"]');

    function syncCourseName() {
        if (!courseNameInput || !trainingCourseNameInput) return;
        courseNameInput.value = trainingCourseNameInput.value;
    }

    if (trainingCourseNameInput) {
        trainingCourseNameInput.addEventListener('input', syncCourseName);
    }

    // 初期表示時に既に登録されていれば自動計算
    calculateEmploymentPeriod();
    calculateStudentDeadline();
    calculateBranchFirstSubmission();
    calculateBranchDeadline();
    calculateInsuranceRateDate();
    syncCourseName();
});
